Controller = App.loadClass 'core::Angular/Controller'

class exports.ManagementSystemController extends Controller
    constructor: (
        @scope
        @transitions
        @modal
        @http
        @service
        @state
        @anchorScroll
        @location
        @timeout
    ) ->
        super

        @filterMap =
            fallTillage: 'fall_tillage'
            coverCrop: 'cover'
            manure: 'manure'
            fertilizer: 'fertilizer'

        @service.onDataLoaded @scope, () =>
            Promise.all([
                @http.get "/backend/grower/fieldprint/custom-rotations/#{@service.crop}"
                @http.get "/backend/grower/fieldprint/crlmod/#{@service.crop}/#{@service.field}"
                @http.get "/backend/grower/fieldprint/tillage-template/#{@service.fpcResult.data.management_system}" if @service.fpcResult.data.management_system
            ])
            .then (responses) -> [responses[0].data, responses[1].data, responses[2]?.data]
            .then (data) =>
                [custom, crlmod, tmt] = data
                @crlmod = custom.map (c) ->
                    c.is_custom = true
                    return c
                .concat(crlmod)
                if tmt
                    tmt.is_tmt = true
                    @crlmod.unshift tmt
                @filteredCrlmod = @crlmod.slice()

                if @service.fpcResult?.data?
                    if not @service.fpcResult.data.management_system_filters? or @service.fpcResult.data.management_system_filters.constructor is Array
                        @service.fpcResult.data.management_system_filters = {}

                    if @service.fpcResult.data.management_system
                        @setManagementSystemDetails @service.fpcResult.data.management_system
                    else if @service.fpcResult.data.custom_rot
                        @setManagementSystemDetails @service.fpcResult.data.custom_rot, true
                    else if @service.fpcResult.data.crlmod
                        @setManagementSystemDetails @service.fpcResult.data.crlmod

                    # If not management system not already selected, autoset the covercrop filter
                    if (
                        (not @service.fpcResult.data.crlmod and not @service.fpcResult.data.custom_rot and not @service.fpcResult.data.management_system) and
                        @service.fpcResult.data.management_system_filters.coverCrop isnt @service.hasCoverCropEvents()
                    )
                        @setFilter 'coverCrop', @service.hasCoverCropEvents()

                    @applyFilters()

        @scope.uploadCustomRotation = (file) =>
            return unless file
            reader = new FileReader()
            reader.onload = () =>
                json = reader.result
                try
                    rotObj = JSON.parse json
                catch
                    @scope.customRotError = 'Invalid file format'
                    console.error 'Not a correct format'
                    return
                events = rotObj.managements?[0]?.events
                unless events
                    @scope.customRotError = 'Invalid file format'
                    console.error 'No events object in json'
                    return
                @http.post '/backend/grower/fieldprint/custom-rotations',
                    name: file.name
                    events: events
                    crop_id: @service.fpcResult.ftm_crop.id
                .then (response) =>
                    @scope.customRotError = ''
                    customRot = response.data
                    customRot.is_custom = true
                    @crlmod.unshift customRot
                    @service.fpcResult.data.management_system_filters = {}
                    @applyFilters()
                    @setManagementSystem customRot
                .catch (err) =>
                    @scope.customRotError = err.data.message
                    console.error err
            reader.readAsText file


    openMgmtSystemDialog: () =>
        @modal.open
            windowClass: 'medium_dialog'
            templateUrl: 'backend/grower/fieldprint/mgmt-system-dialog'
            controller: 'DialogController'

    setManagementSystem: (system) =>
        if system.is_custom
            if @service.fpcResult.data.custom_rot is system.id
                @service.fpcResult.data.custom_rot = null
                return

            # Clear crlmod id and management system
            @service.fpcResult.data.crlmod = null
            @service.fpcResult.data.management_system = null
            @service.fpcResult.data.custom_rot = system.id
        else
            if @service.fpcResult.data.crlmod is system.id
                @service.fpcResult.data.crlmod = null
                return

            # Clear custom id and management system
            @service.fpcResult.data.custom_rot = null
            @service.fpcResult.data.management_system = null
            @service.fpcResult.data.crlmod = system.id
        @setManagementSystemDetails system.id, system.is_custom

    setManagementSystemDetails: (management_id, is_custom) =>
        activities = []
        data = @crlmod.find((management) =>
            +management.id is +management_id and management.is_custom is is_custom
        ).event_strings

        for k, v of data
            pieces = v.split ' - '
            activity =
                season: pieces[0]
                activity: pieces[1]
            activities.push activity

        @managementSystemDetails = activities
        @autoScroll()

    autoScroll: () =>
        @timeout () =>
            # Also scroll the table to the selected system
            return if not @service.fpcResult.data.crlmod and not @service.fpcResult.data.custom_rot and not @service.fpcResult.data.management_system
            if @service.fpcResult.data.management_system?
                newHash = "managementSystem#{@service.fpcResult.data.management_system}tmt"
            else if @service.fpcResult.data.custom_rot?
                newHash = "managementSystem#{@service.fpcResult.data.custom_rot}cr"
            else
                newHash = "managementSystem#{@service.fpcResult.data.crlmod}"
            if @location.hash() isnt newHash
                @location.hash newHash
            else
                @anchorScroll()

    setFilter: (filter, selection) =>
        if selection is @service.fpcResult.data.management_system_filters[filter]
            @service.fpcResult.data.management_system_filters[filter] = null
        else
            @service.fpcResult.data.management_system_filters[filter] = selection

        # clear Fall Tillage so things don't get screwy
        if filter is 'tillageSystem' and @service.fpcResult.data.management_system_filters?.tillageSystem is null or @service.fpcResult.data.management_system_filters?.tillageSystem is 'no-till'
            @service.fpcResult.data.management_system_filters?.fallTillage = null

        @applyFilters()


    # Fall Tillage filter should be enabled if Tillage System is Strip or Conventional
    fallEnabled: () =>
        return @service.fpcResult.data?.management_system_filters?.tillageSystem is null or @service.fpcResult.data?.management_system_filters?.tillageSystem is 'no-till'


    applyFilters: () =>
        @filteredCrlmod = @crlmod.filter (management) =>
            for k, v of @service.fpcResult.data.management_system_filters
                continue if v is null

                if k is 'tillageSystem'
                    return false if not management.tillage_class.toLowerCase().includes v.toLowerCase()
                else
                    managementKey = @filterMap[k]
                    return false if management[managementKey] isnt v
            return true

        if _.filter(@filteredCrlmod, { id: @service.fpcResult.data.crlmod }).length is 0
            @service.fpcResult.data.crlmod = null

        @autoScroll()
